import { BarcodeBlockDetails } from "./barcode-block-details.model";
import { ImageBlockDetails } from "./image-block-details.model";
import { TextBlockDetails } from "./text-block-details.model";

export class Block {
    public id: number;
    public rekbotId: number;
    public name: string;
    public type: string;
    public blockDetails: TextBlockDetails | ImageBlockDetails | BarcodeBlockDetails | undefined

    constructor(
        id: number, 
        rekbotId: number,
        name: string, 
        type: string,
        blockDetails: TextBlockDetails | ImageBlockDetails | BarcodeBlockDetails |undefined
    ) {
        this.id = id;
        this.rekbotId = rekbotId;
        this.name = name;
        this.type = type;
        this.blockDetails = blockDetails;
    }
}